import type { FC } from 'react';

import CommonLayout from './components/CommonLayout';
import GlobalHeader from './components/Header/GlobalHeader';

interface BaseLayoutProps {
    stayAfterLoginLogoutRedirect?: boolean;
}

/**
 * Layout for every page that is not using a more specific Layout, like i.e. EcommerceLayout
 */
const BaseLayout: FC<React.PropsWithChildren<BaseLayoutProps>> = (props) => {
    return (
        <CommonLayout>
            <GlobalHeader
                hideB2BSwitch={false}
                stayAfterLoginLogoutRedirect={props.stayAfterLoginLogoutRedirect}
            />
            {props.children}
        </CommonLayout>
    );
};

export default BaseLayout;
